/**
 * SqlPreviewCode — read-only SQL preview text (compact popover footer,
 * read-only fallback body, DDL card) coloured exactly like the Query Editor.
 *
 * Tokens and colours come from `useEditorSqlTokens`: Monaco's own tokenizer
 * plus the active editor colour scheme — no editor is mounted
 * (`Docs/QueryEditor_CpuIssue.md`). Until Monaco has loaded the text renders
 * plain. Lossless either way: `textContent` equals `sql` exactly.
 */
import { useEditorSqlTokens } from '../../../common/hooks/useEditorSqlTokens';

export interface SqlPreviewCodeProps {
  readonly sql: string;
  readonly className?: string;
}

/** Callers own the surrounding block element (`<pre>` / `<code>`) and its testid. */
export function SqlPreviewCode({ sql, className }: SqlPreviewCodeProps) {
  const tokens = useEditorSqlTokens(sql);
  if (!sql) return null;
  if (!tokens) return <span className={className}>{sql}</span>;
  return (
    <span className={className}>
      {tokens.map((token, i) => (
        <span key={i} data-token={token.kind || undefined} style={token.color ? { color: token.color } : undefined}>
          {token.text}
        </span>
      ))}
    </span>
  );
}
